
import { onMounted, ref, computed } from 'vue';
import ConfigRepository from "@/services/ConfigRepository";
import Config from '@/models/config.models'
import Book from '@/models/book.models'
import Slot from '@/models/slot.models'
import BookRepository from '@/services/BookRepository'
import moment from 'moment';
import { useRouter } from 'vue-router'
import {useToast} from "primevue/usetoast";
import TeamRepository from "@/services/TeamRepository";
import {Team} from "@/models/team.models";
import Province from "@/models/province.models";
import District from "@/models/district.models";
import Ward from "@/models/Ward.models";
import LocationRepository from "@/services/LocationRepository";

export default {

  setup() {
    const router = useRouter();
    const toast = useToast();
    const appConfig = ref({} as Config);
    const book = ref({} as Book);
    const slots = ref([] as Slot[]);
    const isLoadingSlots = ref(false);
    const isSubmitting = ref(false);
    const slot = ref(null);
    const teams = ref({} as Team[]);
    const provinces = ref({} as Province[]);
    const districts= ref({} as District[]);
    const wards = ref({} as Ward[]);
    const province = ref(0);
    const district = ref(0);
    const ward = ref(0);

    book.value.team = 'PTNC';


    TeamRepository.getTeams()
            .then((response) => {
              teams.value = response.data;
            })
            .catch();
    LocationRepository.getProvince()
            .then((response) => {
              provinces.value = response.data;
            })
            .catch();

    const selectProvince = () => {
      LocationRepository.getDistrict(province.value)
              .then((response) => {
                districts.value = response.data;
              })
              .catch();
    }

    const selectDistrict = () => {
      LocationRepository.getWard(district.value)
              .then((response) => {
                wards.value = response.data;
              })
              .catch();
    }

    const formatTime = (date: Date) => {
      return moment(date).format('HH:mm');
    };

    const loadConfig = () => {
      ConfigRepository.getConfig()
        .then((_) => {
          appConfig.value = _.data;
        });
    };

    const valid = () => {
      return book.value.full_name &&
          book.value.date_time &&
          ward.value &&
          book.value.address &&
          book.value.symptoms &&
          book.value.phone_number &&
          slot.value;
    };

    const friendlyDate = (date) => {
      return moment(date).format('HH [giờ] mm [ngày] DD/MM/yyyy');
    }

    const submit = () => {
      const _book = book.value;
      const _time = moment((slot.value!! as Slot).date_time);

      provinces.value.filter(x => {if(x.province_code == province.value) book.value.province_name = x.province_name});
      districts.value.filter(x => {if(x.district_code == district.value) book.value.district_name = x.district_name});
      wards.value.filter(x => {if(x.ward_code == ward.value) book.value.ward_name = x.ward_name});

      _book.date_time.setHours(_time.hour(), _time.minute(), 0);

      isSubmitting.value = true;
      BookRepository.createBook(book.value)
        .then(response => {
          router.push({
            name: 'success',
            query: {
              id: response.data.id,
              date: friendlyDate(response.data.date_time)
            }
          });
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail:err.response.data,
            life: 2500
          });
        })
      .finally(()=>{
        isSubmitting.value = false;
      });

    };

    const loadSlots = () => {
      isLoadingSlots.value = true;
      slots.value = [];
      slot.value = null;
      BookRepository.getSlots(book.value.date_time)
        .then(response => {
          slots.value = response.data;
        })
        .finally(()=> {
          isLoadingSlots.value = false;
        })
    }

    onMounted(loadConfig);

    return {
      appConfig,
      loadConfig,
      book,
      slots,
      loadSlots,
      isLoadingSlots,
      slot,
      formatTime,
      submit,
      isSubmitting,
      valid,
      teams,
      province,
      provinces,
      district,
      districts,
      ward,
      wards,
      selectProvince,
      selectDistrict,
    }
  }
}

